import { MailPopupConfig, MailPopupType } from '../config';
import { StudentJobConfig } from './student-job-config';

export class ProgressConsultConfig extends StudentJobConfig {
  public getPopupConfig(): MailPopupConfig[] {
    return [{ type: MailPopupType.JOB_CHECK }];
  }
}
